import React from "react";

const AgentSettings = ({ childern }) => {
  return <div>{childern}</div>;
};

export default AgentSettings;
